import { DataGrid, MUIButton, MUIDialog, MUISelect, MUITextField } from '@abb/arcadia-ui-react';
import { SERVER_ID_FIELD_MAX_LENGTH } from '@service/constants';
import * as React from 'react';
import { IServer, Server } from '../../../models';
/* tslint:disable:jsx-no-lambda jsx-no-multiline-js*/
export default class ServerTable extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      isModalOpen: false,
      serverToDelete: null,
      preEditServer: new Server(),
      serverId: {
        serverIdFirstSection: '',
        serverIdSecondSection: '',
        serverIdThirdSection: '',
        serverIdFourthSection: ''
      }
    };
  }
  render() {
    const headerData = [
      { id: 'Description', label: 'Description', numeric: false, actions: false, enableSort: false },
      { id: 'HardwareId', label: 'Hardware ID', numeric: false, actions: false, enableSort: false },
      { id: 'OperationalUse', label: 'Operational Use', numeric: false, actions: false, enableSort: false },
      { id: 'Manage', label: 'Manage', numeric: false, actions: false, enableSort: false }
    ];
    const rows = (this.props.server || []).map((row: any, idx: number) => ({
      id: String(row.id ?? idx),
      Description: this.renderDescription(row),
      HardwareId: this.renderServerIdTextInput(row),
      OperationalUse: this.renderComboBoxCol(row, this.props.operationalUsages),
      Manage: this.renderManageButtons(row)
    }));

    return (
      <div>
        <DataGrid name='hardware' enableCheckbox={false} size={40} rowsPerPage={rows.length || 1} headerData={headerData} rows={rows} />
        <MUIDialog
          variant='warning'
          open={this.state.isModalOpen}
          heading='Confirmation'
          content='Deleting hardware removes all corresponding instances. Please confirm.'
          primaryButtonText='Confirm'
          secondaryButtonText='Cancel'
          onClickPrimaryButton={() => {
            this.props.DeleteServer(this.state.serverToDelete);
            this.setState({ isModalOpen: false, serverToDelete: null });
          }}
          secondaryButtonConfig={{ onClick: () => this.setState({ isModalOpen: false, serverToDelete: null }) }}
          onClose={() => { this.closeModal(); }}
        />
      </div>
    );
  }

  componentWillReceiveProps(props: any) {
    if (props.serverIsAddingNew) {
      this.setState({
        serverId: {
          serverIdFirstSection: '',
          serverIdSecondSection: '',
          serverIdThirdSection: '',
          serverIdFourthSection: ''
        }
      });
    }
  }

  closeModal() {
    this.setState({
      isModalOpen: false,
      serverToDelete: null
    });
  }

  renderDescription(server: IServer) {
    if (server.isBeingEdited) {
      return <MUITextField name='NewServerDescription' size={32}
        value={server.description.value}
        errors={server.description.valid ? undefined : { NewServerDescription: { message: 'Description must be unique and cannot exceed 100 characters; may include "-", "_", "(", ")". ' } }}
        onChange={(value: string) => {
          this.props.ServerDescriptionEdit(value);
        }} />;
    }
    return server.description.value;
  }

  renderManageButtons(server: IServer) {

    if (server.isBeingEdited) {
      return <div className="flex-start">
        <MUIButton variant='secondary' size={32} iconName='icon_abb_dias icon-abb_save' onClickButton={() => this.handleSaveEdit(server)} disabled={!server.description.valid || !server.serverId.valid} />
        <MUIButton variant='secondary' size={32} iconName='icon_abb_dias icon-abb_cancel-1' onClickButton={() => this.handleCancelEdit(server)} />
      </div >;
    }
    return <div className="flex-start">
      <MUIButton variant='secondary' size={32} iconName='icon_abb_dias icon-abb_edit' onClickButton={() => this.handleEditExistingRow(server)} />
      <MUIButton variant='secondary' size={32} iconName='icon_abb_dias icon-abb_delete' onClickButton={() => {
        this.setState({
          isModalOpen: true,
          serverToDelete: server
        });
      }} />
    </div>;
  }

  handleEditExistingRow(server: IServer) {
    this.setState({
      preEditServer: server
    });
    this.props.EditExistingRow(server);
    const serverIdSections = server.serverId.value.split('-');
    this.setState({
      serverId: {
        serverIdFirstSection: serverIdSections[0],
        serverIdSecondSection: serverIdSections[1],
        serverIdThirdSection: serverIdSections[2],
        serverIdFourthSection: serverIdSections[3]
      }
    });
  }

  handleSaveEdit(server: IServer) {
    this.props.UpdateServer(server);
    this.setState({
      preEditServer: new Server()
    });
  }

  handleCancelEdit(server: IServer) {
    this.props.ServerCancelEdit(this.state.preEditServer);
    this.setState({
      preEditServer: new Server()
    });
  }

  renderServerIdTextInput(server: IServer) {
    if (server.isBeingEdited) {
      const idErrorMessage = 'Alphanumeric field with 4 sections of 4 characters associated with the actual ServicePort';
      return <div>
        <div className='serverIdInputGroup'>
          <div className='serverIdInput'>
            <MUITextField
              name='NewServerId'
              size={32}
              id='1'
              maxCharacters={SERVER_ID_FIELD_MAX_LENGTH}
              value={this.state.serverId.serverIdFirstSection}
              onChange={(value: string) => {
                this.handleServerIdFieldChange(value, this.state.serverId.serverIdSecondSection, this.state.serverId.serverIdThirdSection, this.state.serverId.serverIdFourthSection);
                this.TabIfMaxLength(value, '1');
              }}
            />
          </div>
          <div className='serverIdInputSeperator'>-</div>
          <div className='serverIdInput'>
            <MUITextField name='NewServerId2'
              size={32}
              id='2'
              maxCharacters={SERVER_ID_FIELD_MAX_LENGTH}
              value={this.state.serverId.serverIdSecondSection}
              onChange={(value: string) => {
                this.handleServerIdFieldChange(this.state.serverId.serverIdFirstSection, value, this.state.serverId.serverIdThirdSection, this.state.serverId.serverIdFourthSection);
                this.TabIfMaxLength(value, '2');
              }} />
          </div>
          <div className='serverIdInputSeperator'>-</div>
          <div className='serverIdInput'>
            <MUITextField name='NewServerId3'
              size={32}
              id='3'
              maxCharacters={SERVER_ID_FIELD_MAX_LENGTH}
              value={this.state.serverId.serverIdThirdSection}
              onChange={(value: string) => {
                this.handleServerIdFieldChange(this.state.serverId.serverIdFirstSection, this.state.serverId.serverIdSecondSection, value, this.state.serverId.serverIdFourthSection);
                this.TabIfMaxLength(value, '3');
              }} />
          </div>
          <div className='serverIdInputSeperator'>-</div>
          <div className='serverIdInput'>
            <MUITextField name='NewServerId4'
              size={32}
              id='4'
              maxCharacters={SERVER_ID_FIELD_MAX_LENGTH}
              value={this.state.serverId.serverIdFourthSection}
              onChange={(value: string) => {
                this.handleServerIdFieldChange(this.state.serverId.serverIdFirstSection, this.state.serverId.serverIdSecondSection, this.state.serverId.serverIdThirdSection, value);
              }} />
          </div>
        </div>
        {!server.serverId.valid && <div className='serverIdErrorMessage'>{idErrorMessage}</div>}
      </div>;
    }
    return server.serverId.value;
  }

  handleServerIdFieldChange(serverIdFirstSection: string, serverIdSecondSection: string, serverIdThirdSection: string, serverIdFourthSection: string) {
    this.setState((prevState: any) => ({
      serverId: {
        ...prevState.serverId,
        serverIdFirstSection,
        serverIdSecondSection,
        serverIdThirdSection,
        serverIdFourthSection
      }
    }));
    this.props.ServerServerIdEdit(serverIdFirstSection + '-' + serverIdSecondSection + '-' + serverIdThirdSection + '-' + serverIdFourthSection);
  }

  TabIfMaxLength(value: string, id: string) {
    if (value.length >= SERVER_ID_FIELD_MAX_LENGTH) {
      document.getElementById((Number(id) + 1).toString())!.focus();
    }
  }

  renderComboBoxCol(server: IServer, operationalUsages: any) {
    if (server.isBeingEdited) {
      const options = (operationalUsages || []).map((u: any) => ({ id: String(u.id), name: u.usageName }));
      const selected = server.operationalUseType ? [String(server.operationalUseType.id)] : [];
      return <MUISelect name={'opUse-' + (server.serverId.value || 'new')} size={32} dropdownLOV={options} selectedItem={selected} onChange={(value: any) => {
        const first = Array.isArray(value) ? value[0] : value;
        const id = Array.isArray(value) && typeof first === 'object' && first !== null ? first.id : first;
        const selectedUsage = (operationalUsages || []).filter((u: any) => String(u.id) === String(id))[0];
        if (selectedUsage) {
          this.props.ServerOperationUseChange({ id: selectedUsage.id, label: selectedUsage.usageName });
        }
      }} />;
    }
    return server.operationalUseType.usageName;
  }
}

export interface IHardwareTableProps {
  preEditServer: IServer;
}
